import React, { useEffect, useState } from "react";
import { listGallery, deleteGallery, withBase } from "./api";
import styles from "./List.module.css";

export default function GalleryList() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    listGallery()
      .then((res) => setItems(res.items || []))
      .catch((e) => setError(e.message || "Failed to load"));
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div className={styles.title}>Gallery Images</div>
      </div>
      {error && <div className={styles.empty}>{error}</div>}
      <div className={styles.tableWrap}>
        <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th className={styles.th}>#</th>
            <th className={styles.th}>Title</th>
            <th className={styles.th}>Image</th>
            <th className={styles.th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td className={styles.empty} colSpan={4}>
                No gallery items found.
              </td>
            </tr>
          ) : (
            items.map((it, idx) => (
              <tr key={it.id}>
                <td className={styles.td}>{idx + 1}</td>
                <td className={styles.td}>{it.title}</td>
                <td className={styles.td}>
                  {it.image_path ? (
                    <div style={{width: '80px', height: '60px', borderRadius: '6px', overflow: 'hidden', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <img className={styles.img} src={withBase(it.image_path)} alt={it.title} />
                    </div>
                  ) : (
                    <span style={{color: '#999'}}>No image</span>
                  )}
                </td>
                <td className={styles.td}>
                  <div className={styles.actions}>
                    <button
                      className={`${styles.btn} ${styles.btnEdit}`}
                      onClick={() => {
                        const params = new URLSearchParams({ id: String(it.id) });
                        window.location.href = `/admin/gallery/add?${params.toString()}`;
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className={`${styles.btn} ${styles.btnDelete}`}
                      disabled={busyId === it.id}
                      onClick={async () => {
                        setBusyId(it.id);
                        try {
                          await deleteGallery(it.id);
                          setItems(items.filter((x) => x.id !== it.id));
                        } catch (e) {
                          setError(e.message || "Delete failed");
                        } finally {
                          setBusyId(null);
                        }
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
}
